import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const fetchPayrollForMonthApi = async (
  userId?: string,
  userIds?: string[],
  month?: number,
  year?: number
) => {
  try {
    const params = userIds
      ? { userIds: userIds.join(","), month, year }
      : { userId, month, year };
    const res = await axiosSetup.get("/payroll/calculate", { params });
    return res.data.data; // Expect array of { userId, username, grossSalaryMonthly, payroll, error? }
  } catch (err: any) {
    throw err?.response?.data?.message || "Failed to fetch payroll";
  }
};

export const fetchPayrollListForMonthApi = async (month: number, year: number) => {
  try {
    const res = await axiosSetup.get("/payroll/calculate/full-final-settlements", {
      params: { month, year },
    });
    return res.data.data;
  } catch (err: any) {
    throw err?.response?.data?.message || "Failed to fetch payroll list";
  }
};

export const fetchEmployeesForSettlementApi = async () => {
  try {
    const res = await axiosSetup.get("/payroll/settlement-users", {
    });
    return res.data.data;
  } catch (err: any) {
    throw err?.response?.data?.message || "Failed to fetch payroll list";
  }
};

export const saveSettlementApi = async (payload: any) => {
  try {
    const res = await axiosSetup.post("/payroll/save/user-settlement", {
      ...payload,
      year: payload.year,
      payrollMonth: payload.payrollMonth,
    });
    return res.data.data;
  } catch (err: any) {
    throw err?.response?.data?.message || "Failed to save settlement";
  }
};